import { faHourglassClock, faTextSize, faUserShield, faVolumeUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const AR_FloatingBar = ({ selectedStudents, onAction, allowedToEdit, enabledReadSpeaker, getToggleStatus, isApiProcessing }) => {
  
  const floatingMenu = [
    {
      id: 1,
      name: 'ActivitiesAccess',
      displayName: 'Activities Access',
      icon: <FontAwesomeIcon icon={faUserShield} />,
      action: () => onAction('ActivitiesAccess', selectedStudents)
    },
    {
      id: 2,
      name: 'TextSelection',
      displayName: 'Text Selection',
      icon: <FontAwesomeIcon icon={faTextSize} />,
      action: () => onAction('TextSelection', selectedStudents)
    },
    {
      id: 3,
      name: 'TextToSpeech',
      displayName: 'Text-To-Speech',
      icon: <FontAwesomeIcon icon={faVolumeUp} />,
      action: () => onAction('TextToSpeech', selectedStudents)
    },
    {
      id: 4,
      name: 'SelfGenTimeOnTask',
      displayName: 'Self Gen Time On Task',
      icon: <FontAwesomeIcon icon={faHourglassClock} />,
      action: () => onAction('SelfGenTimeOnTask', selectedStudents)
    }];

  const disableBtn = (name)=>((!allowedToEdit || !(selectedStudents?.length>0) || isApiProcessing)
      || (name == 'TextToSpeech' && !enabledReadSpeaker));

  return (
    <Row className='flex-center-align'>
      <div className="col-8 d-flex flex-wrap floating-menu-in gap-4">
        {floatingMenu.map((value, index) => (
          <Col key={`col_${index}`}>
            <button disabled={disableBtn(value.name)} className={`btn p-0 ${value.id == 4 ? 'col-12' : 'col-10 fb-vl'}`} onClick={() => value.action()}>
              <div className='d-flex'>
                <div className='align-content-center'>
                  <button className='btn primary-icon-btn rounded-2 fb-icon-btn'>{value.icon}</button>
                </div>
                <div>
                  <div>
                    <button
                      key={`floating-Menu-btn-${index}`}
                      id={`floating-menu-${value.id}`}
                    >
                      <div className='fs-14'>{value.displayName}</div>
                    </button>
                  </div>
                  <div className='d-flex px-2 gap-1'>
                    <div>
                      <Form.Check
                        type="switch"
                        id={`custom-switch${value.id}`}
                        label= {(value.id == 1? (getToggleStatus(value.name) ? ' Assigned' :' Full')
                          : (getToggleStatus(value.name) ? ' Enabled' : ' Disabled'))
                        }
                        checked={getToggleStatus(value.name)}
                        className={'floatingSwitch'}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </Col>
        ))}
      </div>
    </Row>
  );
};

AR_FloatingBar.propTypes = {
  selectedStudents: PropTypes.array,
  onAction: PropTypes.func.isRequired,
  allowedToEdit: PropTypes.bool.isRequired,
  enabledReadSpeaker: PropTypes.bool.isRequired,
  getToggleStatus: PropTypes.func,
  isApiProcessing:  PropTypes.bool
};

export default AR_FloatingBar;